//for-formated
import { graphClient } from '../../graph-client'
import { GET_GAME, GET_GAME_COUNT, GET_GAME_FIRST, GET_GAMES } from './gql'

import type { Get, GetCount, GetFirst, GetList } from './types'

class GameService {
  async get(params: Get.Input) {
    const request = await graphClient.request<Get.Output>(GET_GAME, params)

    return request?.getGame
  }

  async getCount(params: GetCount.Input) {
    const request = await graphClient.request<GetCount.Output>(
      GET_GAME_COUNT,
      params,
    )

    return request?.getGameCount
  }

  async getFirst(params: GetFirst.Input) {
    const request = await graphClient.request<GetFirst.Output>(
      GET_GAME_FIRST,
      params,
    )

    return request?.getGameFirst
  }

  async getList({ take = 20, skip = 0, ...params }: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(GET_GAMES, {
      ...params,
      take,
      skip: take * skip,
    })

    return request?.getGames
  }
}

export const gameService = new GameService()
